export default "__VITE_ASSET__Qoz7WDxL__"